import React, { useState, forwardRef, useImperativeHandle } from 'react';
import { SearchIcon, SendIcon } from 'lucide-react';
interface HeaderProps {
  onQuerySubmit: (question: string) => void;
}
export const Header = forwardRef<{
  resetQuestion: () => void;
}, HeaderProps>(({
  onQuerySubmit
}, ref) => {
  const [question, setQuestion] = useState('');
  // Expose a method to reset the question state
  useImperativeHandle(ref, () => ({
    resetQuestion: () => setQuestion('')
  }));
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (question.trim()) {
      onQuerySubmit(question);
    }
  };
  const suggestions = ['Show me occupancy trends for the last quarter', 'Which residents need medication review this week?', 'Compare staff-to-resident ratios across facilities', 'Identify residents at risk for falls'];
  const handleSuggestionClick = (suggestion: string) => {
    // Only set the question state without submitting
    setQuestion(suggestion);
  };
  return <header className="bg-white border-b border-gray-200 p-4 shadow-sm" data-id="element-127">
      <div className="flex items-center justify-between mb-4" data-id="element-128">
        <h1 className="text-2xl font-bold text-black" data-id="element-129">Further Insights</h1>
        <div className="text-sm text-gray-500" data-id="element-130">Senior Living EHR Analytics</div>
      </div>
      <form onSubmit={handleSubmit} className="flex items-center" data-id="element-131">
        <div className="relative flex-1" data-id="element-132">
          <SearchIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-5 w-5" data-id="element-133" />
          <input type="text" value={question} onChange={e => setQuestion(e.target.value)} placeholder="What can I help with?" className="w-full pl-10 pr-12 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1f58b0] focus:border-transparent" data-id="element-134" />
          <button type="submit" className="absolute right-2 top-1/2 transform -translate-y-1/2 bg-[#1f58b0] text-white p-1.5 rounded-md hover:bg-[#255db7] transition-colors" data-id="element-135">
            <SendIcon className="h-4 w-4" data-id="element-136" />
          </button>
        </div>
      </form>
      <div className="mt-3" data-id="element-137">
        <p className="text-xs font-medium text-gray-500 mb-2" data-id="element-138">Try asking:</p>
        <div className="flex flex-wrap gap-2" data-id="element-139">
          {suggestions.map((suggestion, index) => <button key={index} onClick={() => handleSuggestionClick(suggestion)} className="text-sm bg-gray-100 hover:bg-gray-200 text-gray-700 px-3 py-1.5 rounded-full transition-colors" data-id="element-140">
              {suggestion}
            </button>)}
        </div>
      </div>
    </header>;
});